module.exports = __webpack_public_path__ + "img/10H.14415155.svg";